import type { MeProfile } from '@/api/services/me';

export type ActivityActionCapabilities = {
  canViewUsage: boolean;
  canRetry: boolean;
};

/** Role-gated activity row actions (View usage, Retry). Open is always allowed when linked. */
export function resolveActivityActionCapabilities(
  me: MeProfile | null | undefined,
): ActivityActionCapabilities {
  const readOnly = me?.permissions.readOnly ?? true;
  return {
    canViewUsage:
      !readOnly &&
      Boolean(
        me?.permissions.canViewCustomerBilling ?? me?.permissions.canRunSearch ?? me?.permissions.canCreateSearch,
      ),
    canRetry: Boolean(
      me?.permissions.canManageRecipients ?? me?.permissions.canManageWorkspaceMembers,
    ),
  };
}
